<template>
  <div v-if="getBet.odds.length > 0" :class="{ 'actions-root--sheet': cartSheet }">

    <div class="warning-odds-changed" v-if="warningOddsChanged">
      <span>{{ $t('updateOddsCart') }}</span>
    </div>

    <div v-if="cartWarnings.length > 0" class="cart-warnings-block">
      <div v-for="(warn, i) in cartWarnings" :key="i" class="cart-warning-item">
        <v-icon x-small color="warning" class="mr-1">mdi-alert-outline</v-icon>
        <span>{{ warn.messageKey ? $t(warn.messageKey, warn.messageParams || {}) : $t(warn.message) }}</span>
      </div>
    </div>

    <div v-if="hasSuspendedOdds" class="cart-suspended-block">
      <div class="cart-suspended-item">
        <span class="suspended-dot"></span>
        <span>{{ $t('errors.oddSuspendedReason') }}</span>
      </div>
    </div>

    <div v-if="showAlertLogin">
      <v-alert id="alertLogin" dense text type="error">
        {{ $t('alertlogin') }}
      </v-alert>
    </div>

    <div class="actions">
      <div class="cont_for_btn_book" v-if="getViewMode !== 'detail' && showBookButton">
        <div :class="['btn-book', isBookDisabled ? 'disabled' : '']"
             @click="bookingBet()">
          <svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 6L7.5 5.25H16.5L17.25 6V19.3162L12 16.2051L6.75 19.3162V6ZM8.25 6.75V16.6838L12 14.4615L15.75 16.6838V6.75H8.25Z" fill="currentColor"/>
          </svg>
        </div>
      </div>

      <div class="cont_for_btn_confirm">
        <div v-if="getAuthenticated"
             :class="['btn-confirm', isPlaceDisabled ? 'disabled' : '']"
             @click="saveBet">
          <v-icon x-small v-if="hasBetErrors">
            mdi-block-helper
          </v-icon>
          <span v-else-if="(getBet.type === 'single' || getBet.type === 'multiple')" v-html="$t('place_bet', {amount: round_digits(getBet._multiple_detail.amount, 2) + ' ' + getSettings.currency})"></span>
          <span v-else-if="(getBet.type === 'system')" v-html="$t('place_bet', {amount:  round_digits(getBet._system_detail.amount_system, 2) + ' ' + getSettings.currency})"></span>
          <span v-else-if="(getBet.type === 'integral')" v-html="$t('place_bet', {amount: round_digits(getBet._integral_detail.amount_total, 2) + ' ' + getSettings.currency})"></span>
        </div>

        <div v-else :class="['btn-confirm', isPlaceDisabled ? 'disabled' : '']" @click="alertLogin()">
          <span v-html="$t('place_bet', {amount: getSettings.currencySymbol + round_digits(getBet._multiple_detail.amount, 2)})"></span>
        </div>
      </div>
    </div>



    <transition name="error-bar-slide">
      <div v-if="dialogError && !getModalIdle" class="error-toast-bar">
        <v-icon size="20" color="#ef4444" class="error-toast-bar__icon">mdi-alert-circle</v-icon>
        <div class="error-toast-bar__content">
          <span class="error-toast-bar__code">{{ error_code }}</span>
          <span class="error-toast-bar__reason">{{ formatMessage(error_reason) }}</span>
        </div>
        <button class="error-toast-bar__close" @click="closeModalErrorDialog()">
          <v-icon size="18" color="rgba(255,255,255,0.6)">mdi-close</v-icon>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '../../plugins/eventBus';
import { resolveErrorDisplay } from '@/services/placeBetErrorDisplay';
import { isMobileOnly, isTablet } from 'mobile-device-detect';

export default {
  name: 'Actions',
  inject: { cartSheet: { default: false } },
  props: {
    showBookButton: {
      type: Boolean,
      default: true
    }
  },

  data: function() {
    return {
      dialogError: false,
      error_code: '',
      error_reason: 'n.d.',
      placing: false,
      showAlertLogin: false,
      warningOddsChanged: false,
      print_electron: false,
      icarus: window.icarus,
      attemptsMade: 0,
      MAX_ATTEMPTS: 3,
      _errorDialogTimer: null,
    };
  },

  computed: {
    ...mapGetters({
      getBet:                    'cart/getBet',
      getAuthenticated:          'user/getAuthenticated',
      getLanguage:               'settings/getLanguage',
      getPlatformSettings:       'settings/getPlatformSettings',
      getOddsVariation:          'cart/getOddsVariation',
      getSettings:               'cart/getSettings',
      getType:                   'user/getType',
      getId:                     'user/getId',
      getCashier:                'user/getCashier',
      getElectron:               'settings/getElectron',
      getModalIdle:              'user/getModalIdle',
      getOddsType:               'odds/getOddsType',
      getShortCode:              'settings/getShortCode',
      getEnableClearCartAtPlaceBet: 'settings/getEnableClearCartAtPlaceBet',
      getIsCartUpdating:         'cart/getIsCartUpdating',
      getLoading:                'cart/getLoading',
      getViewMode:               'ui/getViewMode',
      getParentStakeLock:        'cart/getParentStakeLock',
    }),

    isMobile() {
      return isMobileOnly || isTablet;
    },

    isDev() {
      return process.env.NODE_ENV !== 'production';
    },

    hasBetErrors() {
      const { check, errors } = this.getBet;
      return !check && errors.length > 0;
    },

    hasRedundantBbOdds() {
      return (this.getBet.odds || []).some(o => o.bb_redundant === true || o.bb_unavailable === true);
    },

    isPlaceDisabled() {
      // getParentStakeLock: the embedding page has just set the stake, the player sees it first
      return this.hasBetErrors || this.hasRedundantBbOdds || this.placing || this.getIsCartUpdating === true || this.getLoading === true
          || this.getParentStakeLock;
    },

    isBookDisabled() {
      const { context } = this.getBet;
      return this.hasBetErrors ||
          this.hasRedundantBbOdds ||
          this.checkToAcceptNewOdds() ||
          (context !== 'prematch' && context !== 'antepost');
    },

    // Inline warnings above buttons: derived from bet.errors (Vuex source of truth).
    // No longer local state: they persist until the cart is valid again,
    // regardless of modal opening/closing.
    cartWarnings() {
      if (!this.getBet || !this.getBet.errors || this.getBet.errors.length === 0) return [];
      const inlineTypes = ['MULTIPLICITY_TOO_LOW', 'MULTIPLICITY_TOO_HIGH', 'MULTIPLICITY_CONFLICT', 'ODD_DISABLED', 'CHANGED_ODD_VALUE'];
      return this.getBet.errors.filter(function(e) { return inlineTypes.includes(e.type); });
    },

    // Quote sospese (stato transitorio): non sono in bet.errors perché non bloccano
    // il piazzamento. Il warning inline ne avvisa l'utente, che può ritentare.
    hasSuspendedOdds() {
      if (!this.getBet || !this.getBet.odds) return false;
      return this.getBet.odds.some(function(o) { return o.suspended === true; });
    },
  },

  methods: {
    ...mapActions({
      resetCart:             'cart/resetCart',
      removeOddFromCart:     'cart/removeOddFromCart',
      refreshCart:           'cart/refreshCart',
      placeBet:              'cart/placeBet',
      bookBet:               'cart/bookBet',
      replaceOdds:           'cart/replaceOdds',
      acceptAllOdds:         'cart/acceptAllOdds',
      acceptOdd:             'cart/acceptOdd',
      setLoadingCart:        'cart/setLoadingCart',
      addBetInAcceptance:    'cart/addBetInAcceptance',
      updateOddMultiplicity: 'cart/updateOddMultiplicity',
      markOddDisabled:       'cart/markOddDisabled',
      markOddSuspended:      'cart/markOddSuspended',
      clearOddsSuspended:    'cart/clearOddsSuspended',
      markOddChanged:        'cart/markOddChanged',
      applyOddValueChanges:   'cart/applyOddValueChanges',
      setConfirmedBet:       'cart/setConfirmedBet',
      clearConfirmedBet:     'cart/clearConfirmedBet',
    }),

    /**
     * The amount reaches this as a STRING: handleInputDesktop writes the raw
     * input value into `_multiple_detail.amount` and only coerces its copy for
     * verifyAmount. A truthy non-number then had no `.toFixed`, and because
     * this runs during render — refreshCart mutates the cart, Vue re-renders
     * this component — the TypeError broke the render rather than one value,
     * which is how the cart could stop responding until something forced a
     * clean redraw.
     *
     * Coerced here rather than at the input: changing what gets stored would
     * reach the bet payload and every other reader of that field.
     */
    round_digits(value, digits) {
      const n = Number(value);
      const formatted = Number.isFinite(n) ? n.toFixed(digits) : (0.00).toFixed(digits);
      return formatted.replace('.', ',');
    },

    // ── Place bet ─────────────────────────────────────────────────
    async saveBet() {
      const vm = this
      if(this.isPlaceDisabled) return ;
      if (this.placing || this.getIsCartUpdating === true) return;
      if (!await this._beginBetFlow()) return;

      this.placing = true;

      let response;
      try {
        response = await this.placeBet({
          betContext: this.getBet.context,
          lang: this.getLanguage,
          accept_odds: this.getOddsVariation,
        });
      } catch (e) {
        // Unexpected exception (e.g. non-serializable network error)
        this.placing = false;
        await this.setLoadingCart({ status: false });
        this._showErrorDialog(this.$t('errors.systemError'), this.$t('pleaseTryAgain'));
        return;
      }

      this.placing = false;
      await this.setLoadingCart({ status: false });

      if (response && response.result === true) {
        this.attemptsMade = 0;
        await this._onPlaceBetSuccess(response);

      } else {
        await this._onBetError(response, this.saveBet);

      }
    },

    // ── Book bet ────────────────────────────────────────────────
    async bookingBet() {
      const { context } = this.getBet;
      if(this.isBookDisabled) return;
      if ((context !== 'prematch' && context !== 'antepost') || this.getIsCartUpdating === true) return;

      if (!await this._beginBetFlow()) return;

      let response;
      try {
        response = await this.bookBet({ betContext: context, lang: this.getLanguage });
      } catch (e) {
        await this.setLoadingCart({ status: false });
        this._showErrorDialog(this.$t('errors.systemError'), this.$t('pleaseTryAgain'));
        return;
      }

      await this.setLoadingCart({ status: false });

      if (response && response.result === true) {
        await this.setConfirmedBet(this._buildConfirmedBetPayload(response.bet_code, true, null));
        this.dialogError = false;
        this.attemptsMade = 0;
      } else {
        await this._onBetError(response, this.bookingBet);
      }
    },

    // ── Internal helpers ─────────────────────────────────────────────────────

    // Common setup for saveBet and bookingBet: reset state, start loading, block if invalid.
    // Returns true if the flow can continue, false if it must stop.
    async _beginBetFlow() {
      await this.setLoadingCart({ status: true });
      window.scrollTo({ top: 0, behavior: 'smooth' })

      // Reset dei flag di sospensione: il backend ri-decide se la quota è ancora
      // sospesa. Senza questo reset, l'avviso inline rimarrebbe visibile durante
      // il loading anche dopo che l'utente ha cliccato per ritentare.
      if (this.hasSuspendedOdds) {
        await this.clearOddsSuspended();
      }

      if (!this._canSubmit()) {
        await this.setLoadingCart({ status: false });
        return false;
      }
      return true;
    },

    // Checks if the bet can be submitted (cart check)
    _canSubmit() {
      return !this.hasBetErrors;
    },

    // Handles placeBet success (direct print for cashier or confirmed panel)
    async _onPlaceBetSuccess(response) {
      const vm = this
      const betCode = this.getShortCode === true ? response.shortCode : response.bet_code;
      this.warningOddsChanged = false;
      this.dialogError = false;

      // If the backend accepted the bet but with changed odds, update the cart
      // so that refreshCart recalculates all bet-type totals (single/multiple/system/integral).
      // Snapshot old totals BEFORE the update for display purposes.
      const changedOdds = (response.warnings || [])
          .filter(function(w) { return w.code === 'CHANGED_ODD_VALUE'; })
          .map(function(w) { return { outcomeId: w.outcomeId, newOdd: w.newOdd, oldOdd: w.odd }; });

      let oldTotals = null;
      if (changedOdds.length > 0) {
        const bet = this.getBet;
        const t = bet.type;
        if (t === 'single' || t === 'multiple') {
          oldTotals = { odds_total: bet._multiple_detail.odds_total, winning_total: bet._multiple_detail.winning_total };
        } else if (t === 'integral') {
          oldTotals = { odds_total: bet._integral_detail.odds_total_max, winning_total: bet._integral_detail.winning_total_max };
        } else if (t === 'system') {
          oldTotals = { odds_total: 0, winning_total: bet._system_detail.winning_total_max };
        }
        await this.applyOddValueChanges(changedOdds);
        await this.refreshCart();
      }

      const isRetailDirectPrint = this.getElectron &&
          this.getSettings.enableDirectPrintAgency &&
          (this.getType === 4 || (this.getType === 2 && this.getCashier));

      if (isRetailDirectPrint) {
        this.print_electron = true;
        if (this.icarus && window.IcarusInterface) {
          window.IcarusInterface.printTicketRocky(betCode.toString());
        } else {
          window.open(
              this.getPlatformSettings.print_endpoint + betCode + '&electron=1',
              '_blank', 'height=600,width=350'
          );
        }
        this.$root.$emit('cart_handling', true);
        await this.resetCart();
      } else {
        await this.setConfirmedBet(this._buildConfirmedBetPayload(betCode, false, oldTotals));
        // if (this.getEnableClearCartAtPlaceBet === true) {
        //   this.$root.$emit('cart_handling', true);
        //   setTimeout(() => {
        //     vm.resetCart();
        //   }, 150);
        //
        // }
      }
    },

    // oldTotals: { odds_total, winning_total } captured before applyOddValueChanges+refreshCart,
    // null if no odds changed. The cart has already been updated at this point.
    _buildConfirmedBetPayload(betCode, isBooked, oldTotals) {
      const { type, _multiple_detail, _integral_detail, _system_detail } = this.getBet;
      let amount = 0, oddsTotal = 0, winning = 0, winningTotal = 0;

      if (type === 'single' || type === 'multiple') {
        amount      = _multiple_detail.amount;
        oddsTotal   = _multiple_detail.odds_total;
        winning     = _multiple_detail.winning;
        winningTotal = _multiple_detail.winning_total;
      } else if (type === 'integral') {
        amount      = _integral_detail.amount_total;
        oddsTotal   = _integral_detail.odds_total_max;
        winning     = _integral_detail.winning_max;
        winningTotal = _integral_detail.winning_total_max;
      } else if (type === 'system') {
        amount      = _system_detail.amount_system;
        oddsTotal   = 0;
        winning     = _system_detail.winning_max;
        winningTotal = _system_detail.winning_total_max;
      }

      return {
        bet_code:         betCode,
        is_booked:        isBooked,
        type,
        amount,
        odds_total:       oddsTotal,
        old_odds_total:    oldTotals ? oldTotals.odds_total : null,
        winning,
        winning_total:    winningTotal,
        old_winning_total: oldTotals ? oldTotals.winning_total : null,
        bonus:            _multiple_detail.bonus,
        bonus_percentage: _multiple_detail.bonus_percentage,
        odds:             JSON.parse(JSON.stringify(this.getBet.odds)),
      };
    },

    // Common error handler for saveBet and bookingBet.
    // retryFn is the function to call again in case of update_odds with odds_variation active.
    async _onBetError(response, retryFn) {
      const errorCode = response && response.error_code;

      console.error(response);

      // update_odds: handled separately because it involves automatic retry
      if (errorCode === 'update_odds') {
        await this._handleUpdateOdds(response, retryFn);
        return;
      }

      // Sync the cart from structured errors (ODD_DISABLED, ODD_MULTIPLICITY_ERROR)
      // without requiring a page reload
      const apiErrors = (response && response.data && response.data.errors) || [];
      if (apiErrors.length > 0) {
        await this.syncCartFromApiErrors(apiErrors);
        // cartWarnings is now computed from getBet.errors: no manual assignment needed
      }


      if (errorCode !== 'review' ) {
        const display = resolveErrorDisplay(this, response);
        this._showErrorDialog(display.code, display.reason);
      }


      // Side effect for review: adds the bet to the acceptance list with full snapshot
      if (errorCode === 'review' && response.data) {
        await this.addBetInAcceptance(this._buildAcceptancePayload(response.data));
      }
    },

    // Handles update_odds: replaces updated odds and, if allowed, performs an automatic retry.
    // Always guarantees visual feedback to the user at the end of the flow.
    async _handleUpdateOdds(response, retryFn) {
      const dataToUpdate = (response && response.data_to_update) || [];

      await this.replaceOdds({ odds: dataToUpdate });
      this.$root.$emit('forceUpdateOddsSummary');

      if (!this.getOddsVariation) {
        // Without automatic acceptance: updated odds are visible in the cart,
        // the user must manually accept them before trying again.
        return;
      }

      this.warningOddsChanged = true;
      await this.acceptAllOdds();
      await this.refreshCart();

      const hasBlocker = dataToUpdate.some(o => o.reason === 'disabled' || o.reason === 'time_over');

      if (hasBlocker) {
        // An odd is disabled or expired: retry would be useless.
        // Inform the user and leave the cart updated (the odd is already marked as disabled).
        this._showErrorDialog(this.$t('bet_not_accepted'), this.$t('oddNotAvailableInCart'));
        return;
      }

      if (++this.attemptsMade <= this.MAX_ATTEMPTS) {
        await retryFn();
      } else {
        // Attempts exhausted: odds keep changing, the user must decide.
        this.warningOddsChanged = true;
        this._showErrorDialog(this.$t('bet_not_accepted'), this.$t('pleaseTryAgain'));
      }
    },

    // Updates the cart based on structured errors received from the API.
    // Called before showing the modal: the user sees the cart already updated.
    async syncCartFromApiErrors(errors) {
      if (!errors || errors.length === 0) return;

      let needsRefresh = false;

      for (const err of errors) {
        if ((err.code === 'ODD_DISABLED' || err.code === 'ODD_INVALID_STATUS' || err.code === 'UNSUPPORTED_LIVE_EVENT' || err.code === 'time_over' || err.code === 'last_update_over' || err.code === 'invalid_odd') && err.outcomeId) {
          // Disabled, expired, or not updated odd: mark it as disabled
          // so the user visually sees which odd is blocking the bet.
          await this.markOddDisabled({ outcomeId: err.outcomeId });
          needsRefresh = true;
        } else if (err.code === 'ODD_SUSPENDED' && err.outcomeId) {
          // Stato transitorio: la quota può tornare giocabile a breve.
          // Non blocchiamo la scommessa (nessun push a bet.errors): l'utente vede
          // l'avviso inline + il badge sulla riga, e può ritentare il piazzamento
          // quando vuole — clearOddsSuspended ripulirà i flag all'inizio del retry.
          await this.markOddSuspended({ outcomeId: err.outcomeId });
        } else if (err.code === 'ODD_MULTIPLICITY_ERROR' && err.outcomeId) {
          await this.updateOddMultiplicity({
            outcomeId:       err.outcomeId,
            multiplicityMin: err.multiplicityMin,
            multiplicityMax: err.multiplicityMax,
          });
          needsRefresh = true;
        } else if (err.code === 'CHANGED_ODD_VALUE' && err.outcomeId) {
          // The backend rejected the bet because this odd's value changed.
          // Mark it in the cart so the user can review old→new and decide:
          // accept the new value or remove the odd entirely.
          await this.markOddChanged({
            outcomeId: err.outcomeId,
            newOdd:    err.newOdd,
            odd:       err.odd,
          });
          this.warningOddsChanged = true;
          needsRefresh = true;
        }
      }

      if (needsRefresh) await this.refreshCart();
    },

    // Builds a snapshot of the current bet for the acceptance panel.
    // Uses code (not bet_code) so the store filter and socket handlers can find it.
    _buildAcceptancePayload(code) {
      const { type, _multiple_detail, _integral_detail, _system_detail, odds } = this.getBet;
      let amount = 0, oddsTotal = 0, winning = 0, winningTotal = 0, bonus = 0, bonusPercentage = 0;

      if (type === 'single' || type === 'multiple') {
        amount         = _multiple_detail.amount;
        oddsTotal      = _multiple_detail.odds_total;
        winning        = _multiple_detail.winning;
        winningTotal   = _multiple_detail.winning_total;
        bonus          = _multiple_detail.bonus;
        bonusPercentage = _multiple_detail.bonus_percentage;
      } else if (type === 'integral') {
        amount       = _integral_detail.amount_total;
        oddsTotal    = _integral_detail.odds_total_max;
        winning      = _integral_detail.winning_max;
        winningTotal = _integral_detail.winning_total_max;
      } else if (type === 'system') {
        amount       = _system_detail.amount_system;
        winning      = _system_detail.winning_max;
        winningTotal = _system_detail.winning_total_max;
      }

      return {
        code,
        type,
        amount,
        odds_total:       oddsTotal,
        winning,
        winning_total:    winningTotal,
        bonus,
        bonus_percentage: bonusPercentage,
        odds:             JSON.parse(JSON.stringify(odds)),
      };
    },

    _showErrorDialog(code, reason) {
      this.dialogError = true;
      this.error_code = code;
      this.error_reason = reason;
      this._startErrorDialogTimer();
    },

    _startErrorDialogTimer() {
      this._clearErrorDialogTimer();
      this._errorDialogTimer = setTimeout(() => {
        this.closeModalErrorDialog();
      }, 10000);
    },

    _clearErrorDialogTimer() {
      if (this._errorDialogTimer) {
        clearTimeout(this._errorDialogTimer);
        this._errorDialogTimer = null;
      }
    },

    // ── UI Actions ───────────────────────────────────────────────────────────

    async alertLogin() {
      this.showAlertLogin = true;
      if (typeof window !== 'undefined' && window.parent !== window) {
        window.parent.postMessage({ type: 'OPEN_LOGIN' }, '*');
      }
    },

    closeModalErrorDialog: function() {
      this._clearErrorDialogTimer();
      this.dialogError = false;
    },

    checkToAcceptNewOdds() {
      return this.getBet.odds.some(odd => odd.changed);
    },

    formatMessage(msg) {
      return unescape(msg);
    },

    // ── Print (chiamata da $root.$on per bet da MyBets) ─────────────────

    _buildPrintUrl(code) {
      const base = this.getPlatformSettings.print_endpoint + code;
      if (this.print_electron) return `${base}&electron=1`;
      if (this.getShortCode)   return `${base}&login=${this.getType}&ancestors=${this.getId}&type_odd=${this.getOddsType}`;
      return `${base}&type_odd=${this.getOddsType}`;
    },

    printBet(bet) {
      const code = this.getShortCode === true ? bet.betCode : bet.code;
      window.open(this._buildPrintUrl(code), '_blank', 'height=600,width=350');
    },

    // ── Event handlers (EventBus) ───────────────────────────────────────────

    closeModalReserveAlert: function() {
      if (this.error_code === this.$t('betReview')) {
        this.dialogError = false;
      }
    },

    cleanCartAction: function() {
      if (this.getEnableClearCartAtPlaceBet === true) {
        this.dialogError = false;
        this.warningOddsChanged = false;
        this.showAlertLogin = false;
        this.$root.$emit('cart_handling', true);
        this.resetCart();
        this.clearConfirmedBet();
      }
    },
  },

  mounted() {
    this.$root.$on('print_this_bet', this.printBet);
    EventBus.$on('closeModalReserveAlert', this.closeModalReserveAlert);
    EventBus.$on('cleanTheCart', this.cleanCartAction);
  },

  beforeDestroy() {
    this._clearErrorDialogTimer();
    this.$root.$off('print_this_bet', this.printBet);
    EventBus.$off('closeModalReserveAlert', this.closeModalReserveAlert);
    EventBus.$off('cleanTheCart', this.cleanCartAction);
  },
};
</script>
<style scoped>
/* ── Warning odds changed ────────────────────────────────── */
.warning-odds-changed {
  padding: 8px 12px;
  text-align: center;
  background: rgba(245, 158, 11, 0.1);
  border-top: 1px solid rgba(245, 158, 11, 0.25);
  border-bottom: 1px solid rgba(245, 158, 11, 0.25);
}

.warning-odds-changed span {
  font-size: var(--font-size-2xl);
  color: var(--warning, #f59e0b);
  font-weight: 500;
}

/* ── Inline cart warning (ODD_DISABLED / ODD_MULTIPLICITY_ERROR) ──── */
.cart-warnings-block {
  padding: 6px 12px;
  background: rgba(239, 68, 68, 0.07);
  border-bottom: 1px solid rgba(239, 68, 68, 0.2);
}

.cart-warning-item {
  display: flex;
  align-items: center;
  font-size: var(--font-size-xl);
  color: var(--danger, #ef4444);
  font-weight: 500;
  padding: 2px 0;
}

/* ── Inline cart info (ODD_SUSPENDED): non-blocking, transient ── */
.cart-suspended-block {
  padding: 6px 12px;
  background: rgba(245, 158, 11, 0.08);
  border-bottom: 1px solid rgba(245, 158, 11, 0.22);
}

.cart-suspended-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-xl);
  color: var(--warning, #f59e0b);
  font-weight: 500;
  padding: 2px 0;
}

.suspended-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--warning, #f59e0b);
  flex-shrink: 0;
  animation: suspended-pulse 1.6s ease-in-out infinite;
}

@keyframes suspended-pulse {
  0%, 100% { opacity: 0.4; transform: scale(0.85); }
  50%      { opacity: 1;   transform: scale(1); }
}

/* ── Action buttons row ──────────────────────────────────── */
.actions {
  display: flex;
  border-radius: 8px;
  padding: 8px;
  background: var(--sidebar);
  margin-top: 8px;
}

.cont_for_btn_book{
  flex: 0 0 10%;
  box-sizing: border-box;
}

.cont_for_btn_confirm {
  flex: 1;
  padding: 0 0 0 4px;
  box-sizing: border-box;
}

.actions:not(:has(.cont_for_btn_book)) .cont_for_btn_confirm {
  padding: 0;
}

/* Book button — outlined */
.btn-book {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 4px;
  color: #cbd5e1;
  font-size: var(--font-size-xl);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  user-select: none;
}

.btn-book:not(.disabled):hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.45);
}

.btn-book.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* Confirm button — filled primary */
.btn-confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 38px;
  background: var(--btn-background);
  border: none;
  border-radius: 4px;
  color: var(--btn-text);
  font-size: var(--font-size-3xl);
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
}

.btn-confirm .winn_tot{
  font-size: var(--font-size-md);
  text-transform: inherit;
  font-weight: 500;
}


.btn-confirm:not(.disabled):hover {
  transform: translateY(-2px);
}

.btn-confirm.disabled {
  background: rgba(255, 255, 255, 0.07);
  color: #64748b;
  cursor: not-allowed;
}

/* Login to bet — full width CTA */
.btn-login-cart {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 38px;
  background: var(--color-primary, #007aff);
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-size: var(--font-size-xl);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  cursor: pointer;
  transition: background 0.15s;
  user-select: none;
}

.btn-login-cart:hover {
  background: var(--color-primary-hover, #1f89ff);
}

/* ── Close button inside the card ───────────────────── */
/* Positioned inside bounds: visible and tappable on mobile */
.modal-close-btn {
  position: absolute !important;
  top: 8px;
  right: 8px;
  z-index: 1;
  /* Vuetify v-btn icon already has min 36x36px, sufficient for the touch target */
}

/* ── Error modal footer ────────────────────────────────── */
.msg-error-btn {
  display: flex;
  justify-content: center;
  padding: 8px 16px 16px;
}

.close-error-btn {
  text-transform: uppercase !important;
  font-size: var(--font-size-xl) !important;
  letter-spacing: 0.04em !important;
  min-width: 140px;
}

/* ── Confirmation / error modal ──────────────────────────── */
.header-modal-confirmed-bet {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px 16px 12px;
  font-size: var(--font-size-5xl);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #22c55e;
}

.success-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.12);
  border: 2px solid rgba(34, 197, 94, 0.3);
}

.header-modal-error {
  color: #ef4444;
}

.error-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.12);
  border: 2px solid rgba(239, 68, 68, 0.3);
}

.header-modal-confirmed-bet .error_bet {
  fill: var(--danger, #ef4444) !important;
  color: var(--danger, #ef4444) !important;
}

/* Bet code display */
.message-bet-success {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px 16px;
}

.bet-code-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 10px 14px;
}

.bet-code {
  font-family: 'Courier New', Courier, monospace;
  font-size: var(--font-size-8xl);
  font-weight: 800;
  letter-spacing: 0.12em;
}

.copy-btn {
  opacity: 0.5;
  transition: opacity 0.15s, transform 0.1s;
}

.copy-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* Error reason */
.reason-mess {
  display: block;
  font-size: var(--font-size-3xl);
  color: #8a94a6;
  text-align: center;
  padding: 4px 16px 12px;
}

/* Buttons inside modal */
.msg-success-bet-button {
  display: flex;
  gap: 8px;
  padding: 12px 16px 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.print-btn, .newBet-btn, .reloadBet-btn {
  text-transform: uppercase !important;
  font-size: var(--font-size-xl) !important;
  letter-spacing: 0.04em !important;
}


/* ── Error toast bar ── */
.error-toast-bar {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  min-width: 280px;
  max-width: min(400px, calc(100vw - 32px));
  background: var(--bg-card);
  border: 1px solid #ef444466;
  border-left: 3px solid #ef4444;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.45);
  pointer-events: auto;
}
.error-toast-bar__icon { flex-shrink: 0; }
.error-toast-bar__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.error-toast-bar__code {
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: var(--text-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
}
.error-toast-bar__reason {
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.error-toast-bar__close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* Animazione slide-down dall'alto */
.error-bar-slide-enter-active,
.error-bar-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.28s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.error-bar-slide-enter { opacity: 0; transform: translateY(-12px); }
.error-bar-slide-leave-to { opacity: 0; transform: translateY(-12px); }

@media (max-width: 600px) {
  .error-toast-bar {
    top: 16px;
    left: 16px;
    right: 16px;
    min-width: 0;
    max-width: none;
    width: auto;
  }
}

/* ── Bottom sheet mobile ─────────────────────────────────── */
.actions-root--sheet .actions {
  padding: 0;
  margin-top: 0;
  background: transparent;
  gap: 8px;
}

.actions-root--sheet .cont_for_btn_book {
  flex: 0 0 52px;
}

.actions-root--sheet .cont_for_btn_confirm {
  padding: 0;
}

.actions-root--sheet .btn-book {
  height: 42px;
  border-radius: 12px;
}

.actions-root--sheet .btn-confirm {
  height: 42px;
  border-radius: 12px;
  font-size: var(--font-size-3xl);
  font-weight: 700;
}

.actions-root--sheet .btn-confirm:not(.disabled):hover {
  transform: none;
}

.actions-root--sheet .btn-confirm:not(.disabled):active {
  transform: scale(0.98);
}

.actions-root--sheet .warning-odds-changed,
.actions-root--sheet .cart-warnings-block,
.actions-root--sheet .cart-suspended-block {
  margin-bottom: 10px;
  border: none;
  border-radius: 10px;
}
</style>